// @flow
import dateFormat from "../../utils/localdateformat";
import { fetchRest } from "../rest";

export const fetchBlogs = async () => {
    const blogs = await fetchRest("diaries");
    console.log({ blogs });
    for (let i = 0; i < blogs.length; i += 1) {
        const blog = blogs[i];

        if (blog.endDate === "0000-00-00") {
            blog.endDate = blog.startDate;
        }
        blog.searchText = `${blog.title} - ${dateFormat(
            blog.startDate,
            "mmmm yyyy"
        )} - ${dateFormat(blog.endDate, "mmmm yyyy")}`.toLowerCase();
    }

    return blogs;
};

export const fetchBlog = async blogId => fetchRest("diary", { diaryId: blogId });

export const fetchBlogImages = async blog =>
    fetchRest("images", { startDate: blog.startDate, endDate: blog.endDate });



// WEBPACK FOOTER //
// ./src/rest/blogs-context/index.js